// extracted by mini-css-extract-plugin
module.exports = {"expandableStyles":"hZekf","content":"_3DsaL","collapsed":"_1Aax0","small":"_1TgMg","expanded":"_1XEt8"};